import { render, staticRenderFns } from "./confirm-variation.vue?vue&type=template&id=97668dac"
import script from "./confirm-variation.vue?vue&type=script&lang=js"
export * from "./confirm-variation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports